(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["features-zero-nav"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('features-sticky-navigation')) return;

  customElements.define('features-sticky-navigation', class extends HTMLElement {
    connectedCallback() {
      this.navigation = this.querySelector('.vue-features-navigation-static');
      if (!this.navigation) return;

      this.visible = false;
      this.frame = null;
      this.scheduleUpdate = () => {
        if (this.frame !== null) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.updateVisibility();
        });
      };

      window.addEventListener('scroll', this.scheduleUpdate, { passive: true });
      window.addEventListener('resize', this.scheduleUpdate);
      window.addEventListener('pageshow', this.scheduleUpdate);

      // Also update when an asynchronously loaded header moves the trigger.
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(this.scheduleUpdate, {
          rootMargin: '4px 0px 4px 0px',
          threshold: 0
        });
        this.observer.observe(this);
      }

      this.updateVisibility();
    }

    updateVisibility() {
      // This zero-height trigger never moves when the fixed navigation appears.
      // Separate show/hide boundaries absorb fractional pixels and scroll bounce.
      const top = this.getBoundingClientRect().top;
      if (top <= -4) this.visible = true;
      else if (top >= 4) this.visible = false;

      this.navigation.classList.toggle('is-show', this.visible);
      this.navigation.inert = !this.visible;
      this.navigation.setAttribute('aria-hidden', String(!this.visible));
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.scheduleUpdate);
      window.removeEventListener('resize', this.scheduleUpdate);
      window.removeEventListener('pageshow', this.scheduleUpdate);
      this.observer?.disconnect();
      if (this.frame !== null) cancelAnimationFrame(this.frame);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
